import { render, staticRenderFns } from "./achievementRecord.vue?vue&type=template&id=5d264cff&scoped=true"
import script from "./achievementRecord.vue?vue&type=script&lang=js"
export * from "./achievementRecord.vue?vue&type=script&lang=js"
import style0 from "./achievementRecord.vue?vue&type=style&index=0&id=5d264cff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d264cff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d264cff')) {
      api.createRecord('5d264cff', component.options)
    } else {
      api.reload('5d264cff', component.options)
    }
    module.hot.accept("./achievementRecord.vue?vue&type=template&id=5d264cff&scoped=true", function () {
      api.rerender('5d264cff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/examCenterOwn/achievementRecord/achievementRecord.vue"
export default component.exports